export const commentReadCountRequest = (taskDetails) => {
    let requestBody, taskListId = [];
    taskDetails.map((task, index, element) => (
        taskListId.push(task.taskSectionMetadata.taskId)
    ))
    requestBody = {
        taskIdList: taskListId
    }
    return requestBody
}
export const getTableData = (commentReadData, tasks) => {
    let readStatusData = Object.entries(commentReadData);
    tasks.map((item, index, element) => {
       return readStatusData.map(readData => {
            if (item.taskSectionMetadata.taskId === readData[0]) {
                return item.commentCount = readData[1]
            }
        })
    })
    return tasks
}